var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132520",
    "data-name": "Group 132520",
    transform: "translate(-1440 -30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1137",
    "data-name": "Ellipse 1137",
    transform: "translate(1440 30)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close",
    "data-name": "Icon ionic-ios-close",
    d: "M16.233,15.287,19.09,12.43a.669.669,0,0,0-.947-.947l-2.857,2.857-2.857-2.857a.669.669,0,1,0-.947.947l2.857,2.857-2.857,2.857a.669.669,0,0,0,.947.947l2.857-2.857,2.857,2.857a.669.669,0,0,0,.947-.947Z",
    transform: "translate(1436.715 26.712)",
    fill: "#ffcd00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerClose);
export default __webpack_public_path__ + "static/media/drawer-close.c3d94722a0bf17a352b83ff45f9f2d9c.svg";
export { ForwardRef as ReactComponent };